export default __webpack_public_path__ + "static/media/settings-icon.47f0e74b.svg";